import React from 'react';

import DocumentState from './DocumentState';
import Dropzone from '../../../components/widgets/WidgetDropZone';
import File from '../../../components/widgets/WidgetFile';


function Document({ user, setUser, title, description, type_dossier, document_name, facultatif }) {
  var document = null;
  if (type_dossier == 'deuxieme_locataire') {
    document = user.dossier.deuxieme_locataire.documents[document_name];
  } else if (type_dossier == 'dossier') {
    document = user.dossier.documents[document_name];
  } else {
    document = user.dossier.list_garants[type_dossier].documents[document_name];
  }

  const locked = !(user.dossier.etat === 'incomplet' || document.etat === 'manquant' || document.etat === 'attente' || document.etat === 'rejet');

  return (
    <>
      <hr className='mb-6'></hr>
      <div className='col-span-12 w-full grid grid-cols-12 gap-4 pb-6'>
        <div className='col-span-8 w-full'>
          <h3>{title}</h3>
        </div>

        <DocumentState etat={document.etat} facultatif={facultatif} />

        <div className='col-span-12 w-full'>
          {description}
        </div>

        <div className='col-span-12 w-full text-red-600 font-bold'>
          {document.etat === 'rejet' && document.message}
        </div>

        <div className="col-span-12 grid grid-cols-12 gap-4">
          <div className="col-span-6 grid grid-cols-12 h-min">
            {Object.keys(document.fichiers).map(key => {
              const file = document.fichiers[key];
              return (<File key={key} id_client={user._id} type_dossier={type_dossier} document_name={document_name} index={key} path={file.path} name={file.nom} setUser={setUser} locked={locked} ></File>)
            })}
          </div>
          {!locked &&
            <div className="col-span-6 mb-2 mr-2">
              <Dropzone type_dossier={type_dossier} document_name={document_name} user={user} setUser={setUser}></Dropzone>
            </div>
          }
        </div>
      </div>
    </>
  );
}

export default Document;